import { createAsyncThunk } from "@reduxjs/toolkit";
import { TalesFood } from "../../../utils/types/TalesFood";
import { db, storage } from "../../../firebase/config";
import firebase from "firebase/app";

export const deleteFood = createAsyncThunk(
  "food/delete",
  async (food: TalesFood) => {
    try {
      const logoUrl = food.logoUrl;
      let storageRef: firebase.storage.Reference | undefined;
      if (logoUrl) {
        storageRef = storage.refFromURL(logoUrl);
      }

      const querySnapshot = await db
        .collection("food")
        .where("title", "==", food.title)
        .get();

      return querySnapshot.docs[0].ref
        .delete()
        .then(() => storageRef?.delete());
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Food non eliminato, ${e.message}`);
    }
  },
);
